import React, { lazy, useEffect, useState, Suspense, memo } from 'react';
import { addBiEventLiveSite } from '../../widdgetUtils/biEventsHandlers';
import { Loader } from '@wix/calendar-client-library-v3';
import {
  getStyleParams,
  isEditorViewMode,
  setHeight,
  resizeComponent,
} from '../../../../utils';

const AgendaCalendar = lazy(() =>
  import(
    '@wix/calendar-client-library-v3/dist/src/components/containers/AgendaCalendar/AgendaCalendar'
  ),
);
// const AgendaCalendar = lazy(() =>
//   import(
//     '../localCalendars/components/containers/AgendaCalendar/AgendaCalendar'
//   ),
// );

const AgendaWrapper = ({ calendarsProps }) => {
  const {
    isPreLoaded,
    calendarRef,
    isFixedSize,
    isMobile,
    handleMonthChange,
    onTodayClick,
    locale,
    isLiveSite,
  } = calendarsProps;

  const isEditor = isEditorViewMode();

  const [dimensions, setDimensions] = useState({
    height: window.innerHeight,
    width: window.innerWidth,
  }); // use for seting base size on component did mount, dont rewrite setDimensions values

  const agendaDesktop = getStyleParams()?.numbers?.layoutIcons === 2;
  const agendaMobile = getStyleParams()?.numbers?.mobile_layoutIcons === 2;

const setHeightByref = () => {
  setTimeout(() => {
    const calendarElement = calendarRef?.current;
    if (calendarElement) {
      const [header, calendarContent] = calendarElement.children;
      const table = calendarContent?.querySelector('table');
      const headerHeight = (header?.scrollHeight || 0);
      const tableHeight = (table?.scrollHeight || 0) + 40;
      const calendarContentHeight = calendarContent?.scrollHeight || 0;

      setHeight(((tableHeight > 0 && tableHeight > calendarContentHeight) ? tableHeight : calendarContentHeight) + headerHeight);
    }
  }, 1900);
};

  useEffect(() => {
    setTimeout(() => {
      if (agendaMobile && isMobile) {
        resizeComponent({
          height: dimensions.height,
          width: window.innerWidth
        });
      }
      if (agendaDesktop && !isMobile) {
        if (isFixedSize) {
          setHeight(dimensions.height);
        } else {
          setHeightByref();
        }
      }
    }, 500);
  }, [isFixedSize, isMobile, agendaDesktop]);

  useEffect(() => {
    const minHeightResize = () => {
      if (isEditor) {
        const height = window.innerHeight;
        const width = window.innerWidth;
        let minHeight: number = 0;
        let minWidth: number = 0;

        if (agendaDesktop && !isMobile) {
          minWidth = 460;
          minHeight = isFixedSize ? 500 : calendarRef.current.scrollHeight;
        }
        if (agendaMobile && isMobile) {
          minWidth = 320;
          minHeight = 500;
        }

        if (width < minWidth) {
          resizeComponent({ width: minWidth, height });
        }
        if (height < minHeight) {
          resizeComponent({ width, height: minHeight });
        }
      }
    };

    window.addEventListener('resize', minHeightResize, false);
    return () => window.removeEventListener('resize', minHeightResize);
  });

  const handleShowMore = () => {
    setHeight(calendarRef.current.scrollHeight);
    addBiEventLiveSite('show_more_events', true, false, false);
  };

  const onShowPastEventsClick = () => {
    addBiEventLiveSite('show_past_events', true, false, false);
    setHeight(calendarRef.current.scrollHeight);
  };

  const handleMonthChangeResize = (props) => {
    if (isFixedSize) {
      setHeight(dimensions.height);
    } else {
      setHeightByref();
    }
    return handleMonthChange(props);
  };

  const onTodayClickHandlerResize = () => {
    if (isFixedSize) {
      setHeight(dimensions.height);
    } else {
      setHeightByref();
    }
    return onTodayClick();
  };

  const updatetCalendarsProps = {
    ...calendarsProps,
    handleShowMore,
    onShowPastEventsClick,
    handleMonthChange: handleMonthChangeResize,
    onTodayClick: onTodayClickHandlerResize,
  };

  return (
    <Suspense
      fallback={() => (
        <Loader
          locale={locale}
          isPreLoaded={isPreLoaded}
          isLiveSite={isLiveSite}
        />
      )}
    >
      <AgendaCalendar {...updatetCalendarsProps} />
    </Suspense>
  );
};

export default memo(AgendaWrapper);
